class @App.Components.Photogrid
  constructor: ->
    @gridSelector = '[data-component="photogrid"]'
    @photoSelector = '[data-photo]'
    @moreAction = '[data-action="photogrid-more"]'
    @numToShow = 6

    $(@gridSelector).each((i, grid) =>
      $photos = $(grid).find(@photoSelector)

      $photos.slice(0, 3).each((i, photo) => @addImage($(photo)))
      $photos.slice(3).hide()

      $(grid).magnificPopup(
        delegate: @photoSelector
        type: 'image'
        key: 'photogrid-gallery'
        gallery:
          enabled: true
      )
    )

    $('body').on 'click', @moreAction, (e) =>
      e.preventDefault
      @showPhotos($(e.target))
      false


  showPhotos: ($target) =>
    $grid = $target.closest(@gridSelector)
    $photos = $grid.find(@photoSelector)
    start = $grid.find(@photoSelector + ':hidden').first().index()
    end = start + @numToShow

    $photos.slice(start, end).each((i, photo) => @addImage($(photo)))
    $photos.slice(start, end).fadeIn()

    if ($grid.find(@photoSelector + ':hidden').length < 1)
      $grid.find('[data-action="photogrid-more"]').hide()

    return

  addImage: ($photo) =>
    $photo.append($('<img />').attr('src', $photo.data('photo')))
    return

$ ->
  new App.Components.Photogrid
